import React, { useState, useEffect } from 'react';
import { Button, Box, Typography, Grid, TextField } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";

import AboutUs from '../Components/AboutUs/Aboutus';
import TaxiComponent from "../Components/FillerComponents/Taxiservices"
import BikeRentalComponent from '../Components/FillerComponents/Bikeservices';

const Contactuss = () => {
  const travelOwnerNumber = "8435541370"; // Replace with the actual WhatsApp number

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: ""
  });


  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top when component mounts
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    const { name, email, phone, message } = formData;

    if (!name || !email || !phone || !message) {
      alert("Please fill all fields");
      return;
    }

    const whatsappMessage = `Contact Inquiry:
    - Name: ${name}
    - Email: ${email}
    - Phone: ${phone}
    - Message: ${message}`;

    const whatsappURL = `https://wa.me/${travelOwnerNumber}?text=${encodeURIComponent(whatsappMessage)}`;
    window.open(whatsappURL, "_blank");
  };

  return (
    <div>
      <TaxiComponent />
      <AboutUs />
      <Box sx={{ maxWidth: "1200px", margin: "auto", padding: "20px 20px", marginTop: '-50px' }}>
        
        {/* Contact Section */}

        <Grid container spacing={4} alignItems="center" sx={{ marginTop: "60px" }}>
          <Grid item xs={12} md={6}>
            <Typography variant="h6" color="orange" gutterBottom>Contact With Us</Typography>
            <Typography variant="h4" fontWeight="bold" gutterBottom>Book Your Ride</Typography>
            <Typography variant="h6" fontWeight="bold">Brother Taxi Service</Typography>
            <Typography variant="body1" gutterBottom>
              Hotel The Leisure Inn, Joshi Bhawan NH22 to Airport Rd, Kachi Ghatti, Shimla, Himachal Pradesh 171010
            </Typography>
            <Box display="flex" alignItems="center" gap={1}>
              <EmailIcon color="primary" />
              <Typography variant="body1">rakesh.sharma6526@gmail.com</Typography>
            </Box>
            <Box display="flex" alignItems="center" gap={1} sx={{ marginTop: 2 }}>
              <PhoneIcon color="primary" />
              <Typography variant="body1">+91-6230206562</Typography>
            </Box>
          </Grid>

          {/* Form Section */}
          <Grid item xs={12} md={6}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField fullWidth label="Full Name" name="name" variant="filled" onChange={handleChange} />
              </Grid>
              <Grid item xs={6}>
                <TextField fullWidth label="Email Address" name="email" variant="filled" onChange={handleChange} />
              </Grid>
              <Grid item xs={6}>
                <TextField fullWidth label="Phone" name="phone" variant="filled" onChange={handleChange} />
              </Grid>
              <Grid item xs={6}>
                <TextField fullWidth label="Subject" name="subject" variant="filled" />
              </Grid>
              <Grid item xs={12}>
                <TextField fullWidth label="Write a message" name="message" multiline rows={4} variant="filled" onChange={handleChange} />
              </Grid>
              <Grid item xs={12}>
                <Button fullWidth variant="contained" sx={{ backgroundColor: "orange", color: "white" }} onClick={handleSubmit}>
                  Send via WhatsApp
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
            <BikeRentalComponent/>
    </div>
  );
};

export default Contactuss;
